import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import {
  MatTooltip,
  MatTooltipModule,
  TooltipPosition,
} from '@angular/material/tooltip';

@Component({
  selector: 'app-search-bar',
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    MatTooltip,
    ReactiveFormsModule,
  ],
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent {
  @Input() placeholder = 'Search';
  @Input() tooltip = '';
  @Input() tooltipPosition: TooltipPosition = 'above';
  @Input() tooltipDelay = 1000;

  @Output() searchChanged = new EventEmitter<string>();

  searchControl = new FormControl('');

  constructor() {
    this.searchControl.valueChanges.subscribe((value) =>
      this.searchChanged.emit(value || '')
    );
  }
}
